import { createInteriorRoomCalculator } from "./interior-room-shared.js";

/**
 * Dining Room (Phase 13A). Unlike living/family room, a dining room
 * rarely involves exterior windows/doors work as part of the renovation
 * itself, so that category is omitted entirely for this project type
 * (see interior-room-shared.ts's doc comment on per-type inclusion).
 * Its unique addition is a wall treatment (wainscoting, picture-frame
 * moulding, or a wallpapered/panelled accent wall) - a very common
 * dining-room-specific upgrade with real cost impact.
 */
export const calculateDiningRoom = createInteriorRoomCalculator({
  projectType: "dining_room",
  anchorItemId: "dining_room_base_renovation",
  tierFeatures: [
    {
      answerKey: "dining_room_flooring_type",
      itemIdByTier: { not_changing: null, basic: "dining_room_flooring_basic", mid_range: "dining_room_flooring_mid", premium: "dining_room_flooring_premium" },
      quantityFromSqft: true,
      excludedMessage: "Flooring is not changing - excluded from this estimate."
    },
    {
      answerKey: "dining_room_painting",
      itemIdByTier: { not_included: null, walls_only: "dining_room_painting_walls", full_room: "dining_room_painting_full" },
      quantityFromSqft: true,
      excludedMessage: "Painting was not included - excluded from this estimate."
    },
    {
      answerKey: "dining_room_trim",
      itemIdByTier: { keep_existing: null, standard_upgrade: "dining_room_trim_standard", premium_millwork: "dining_room_trim_premium" },
      excludedMessage: "Trim/millwork is not being upgraded - excluded from this estimate."
    },
    {
      answerKey: "dining_room_lighting",
      itemIdByTier: { keep_existing: null, standard_swap: "dining_room_lighting_standard", statement_lighting: "dining_room_lighting_statement" },
      excludedMessage: "Lighting is not being upgraded - excluded from this estimate (a statement chandelier/fixture is a common dining room upgrade if scope changes)."
    },
    {
      answerKey: "dining_room_built_ins",
      itemIdByTier: { none: null, standard: "dining_room_built_ins_standard", custom: "dining_room_built_ins_custom" },
      excludedMessage: "No built-in buffet/hutch cabinetry was requested - excluded from this estimate."
    }
  ],
  booleanFeatures: [
    { answerKey: "dining_room_wall_treatment", itemId: "dining_room_wall_treatment", excludedMessage: "No accent wall treatment (wainscoting, moulding, wallpaper) was requested - excluded from this estimate." }
  ],
  electricalItemId: "dining_room_electrical",
  demolitionItemId: "dining_room_demolition",
  accessibilityItemId: "dining_room_accessibility",
  permitDesignItemId: "dining_room_permit_design"
});
